import { useMemo } from 'react'

const useIsRole = (accountRoles: string[] = [], roles: string[] = []) => {
    return useMemo(() => roles.some(role => accountRoles.includes(role)), [roles, accountRoles])
}

export default useIsRole